import React from 'react';
import { useState, useEffect } from 'react';
import customHeaders, { getSpace } from '../../../../../common/headers';
import useGeneralStore from '../../../../../store/general';
import { ButtonClose, InputDinamycPlaceholder, DropDownSelector, TableBox, Checkbox } from "@lk-gtcom/ecomlab-components";
import { TitlePage } from '../../../../../components/TitlePage/TitlePage';
import { ModalAddFields } from '../../Modal/ModalAddFields/ModalAddFields';
import { DynamicFormComponent } from '../../../../../components/DynamicFormComponent/DynamicFormComponent';
import { ModalComponent } from '../../../../../components/Modal/ModalComponent/ModalComponent';
import './ModalAddServicesCRM.scss'

const option_payment_type = [
    { label: 'фиксированная', value: 'фиксированная' },
    { label: 'расчетная', value: 'расчетная' }
];

const option_payment_part = [
    { label: 'предоплата', value: 'предоплата' },
    { label: 'постоплата', value: 'постоплата' }
];

const option_payment_period = [
    { label: 'разовая', value: 'разовая' },
    { label: 'ежемесячная', value: 'ежемесячная' }
];

interface ModalAddServicesCRMProps {
    setIsModal: (e: boolean) => void
    currentServices: number | null
    setCurrentServices: (e: number | null) => void
    currentDeal: number | string | null
    setCurrentDeal: (e: number | string | null) => void
}

const ModalAddServicesCRM = ({
    setIsModal,
    currentServices,
    setCurrentServices,
    currentDeal,
    setCurrentDeal
}: ModalAddServicesCRMProps) => {
    const selectedSpace = useGeneralStore((state) => state.selectedSpace);
    const headers = { ...customHeaders, ...getSpace(selectedSpace) };

    const [idServices, setIdServices] = useState(null)
    const [name, setName] = useState('')
    const [unit, setUnit] = useState('')
    const [price, setPrice] = useState('')
    const [amountUnit, setAmountUnit] = useState('')
    const [totalSum, setTotalSum] = useState('')
    const [comment, setComment] = useState('')
    const [legalName, setLegalName] = useState('')
    const [active, setActive] = useState(false)
    const [needReport, setNeedReport] = useState(false)
    const [selectedPaymentType, setSelectedPaymentType] = useState(null)
    const [selectedPaymentPart, setSelectedPaymentPart] = useState(null)
    const [selectedPaymentPeriod, setSelectedPaymentPeriod] = useState(null)

    const [contacts, setContacts] = useState([])
    const [isModalContactCRM, setIsModalContactCRM] = useState(false)
    const [isModalFields, setIsModalFields] = useState(false)

    const [contactList, setContactList] = useState([])
    const [contactPage, setContactPage] = useState(1);
    const [contactQuery, setContactQuery] = useState('');
    const [selectedContact, setSelectedContact] = useState(null)

    const currentId = idServices ? idServices : currentServices
    const [fields, setFilds] = useState([]);


    const currentContactList = contactList?.map(({ id, name }) => ({ label: name, value: id }))


    // Получение информации об услуге по id
    const fetchGetInfoServices = (): void => {
        let url = ` https://portals.ecomru.ru/api/crm/services/${currentId}`

        fetch(url, { method: 'GET', headers })
            .then((res) => {
                if (res.ok) {
                    return res.json();
                } else {
                    throw new Error(res.json() as any);
                }
            })
            .then((json) => {
                const {
                    name,
                    unit,
                    active,
                    author,
                    created_at,
                    price_unit,
                    amount_unit,
                    need_report,
                    payment_part,
                    payment_type,
                    payment_period,
                    comment,
                    invoice_name,
                    total
                } = json
                if (name) setName(name)
                if (unit) setUnit(unit)
                if (price_unit) setPrice(price_unit)
                if (amount_unit) setAmountUnit(amount_unit)
                if (active) setActive(active)
                if (need_report) setNeedReport(need_report)
                if (comment) setComment(comment)
                if (invoice_name) setLegalName(invoice_name)
                if (total) setTotalSum(total)
                if (payment_part) {
                    setSelectedPaymentPart({
                        label: payment_part,
                        value: payment_part
                    })
                }
                if (payment_type) {
                    setSelectedPaymentType({
                        label: payment_type,
                        value: payment_type
                    })
                }
                if (payment_period) {
                    setSelectedPaymentPeriod({
                        label: payment_period,
                        value: payment_period
                    })
                }
            })
            .catch((err) => {
                console.error(err);
            });
    };

    // Создание пустой услуги
    const fetchCreateNewServices = () => {
        let url = ` https://portals.ecomru.ru/api/crm/services/`

        fetch(url, { method: 'POST', headers })
            .then((res) => res.json())
            .then((json) => {
                setIdServices(json)
                setCurrentServices(json)
            })
            .catch((err) => console.error(err));
    };

    // Удаление услуги
    const fetchDeleteServices = () => {
        let url = ` https://portals.ecomru.ru/api/crm/services/${currentId}`

        fetch(url, { method: 'DELETE', headers })
            .then((res) => res.json())
            .then((json) => {
                setIdServices(json)
            })
            .catch((err) => console.error(err));
    };

    // Добавить название компании
    const fetchSetName = () => {
        let url = ` https://portals.ecomru.ru/api/crm/services/name`

        const body = JSON.stringify({
            service_id: currentId,
            name
        });

        fetch(url, { body, method: 'PATCH', headers })
            .then((res) => res.json())
            .then((json) => {
                console.log(`name changed`)
            })
            .catch((err) => console.error(err));
    };

    // Добавить ед измерения
    const fetchSetUnit = () => {
        let url = ` https://portals.ecomru.ru/api/crm/services/unit`

        const body = JSON.stringify({
            service_id: currentId,
            unit: unit
        });

        fetch(url, { body, method: 'PATCH', headers })
            .then((res) => res.json())
            .then((json) => {
                console.log(`name changed`)
            })
            .catch((err) => console.error(err));
    };

    // Добавить цену
    const fetchSetPrice = () => {
        let url = ` https://portals.ecomru.ru/api/crm/services/price_unit`

        const body = JSON.stringify({
            service_id: currentId,
            price_unit: price
        });

        fetch(url, { body, method: 'PATCH', headers })
            .then((res) => res.json())
            .then((json) => {
                console.log(`name changed`)
            })
            .catch((err) => console.error(err));
    };

    // Добавить всего
    const fetchSetAmountUnit = () => {
        let url = ` https://portals.ecomru.ru/api/crm/services/amount_unit`

        const body = JSON.stringify({
            service_id: currentId,
            amount_unit: amountUnit
        });

        fetch(url, { body, method: 'PATCH', headers })
            .then((res) => res.json())
            .then((json) => {
                console.log(`name changed`)
            })
            .catch((err) => console.error(err));
    };

    // Добавить общую сумму
    const fetchSetTotalSum = () => {
        let url = ` https://portals.ecomru.ru/api/crm/services/`

        const body = JSON.stringify({
            service_id: currentId
        });

        fetch(url, { body, method: 'PATCH', headers })
            .then((res) => res.json())
            .then((json) => {
                console.log(`total sum changed`)
            })
            .catch((err) => console.error(err));
    };

    // Добавить способ оплаты
    const fetchSetPaymenPart = () => {
        let url = ` https://portals.ecomru.ru/api/crm/services/payment_part`

        const body = JSON.stringify({
            service_id: currentId,
            payment_part: selectedPaymentPart?.value
        });

        fetch(url, { body, method: 'PATCH', headers })
            .then((res) => res.json())
            .then((json) => {
                console.log(`name changed`)
            })
            .catch((err) => console.error(err));
    };

    // Добавить период оплаты
    const fetchSetPaymenPeriod = () => {
        let url = ` https://portals.ecomru.ru/api/crm/services/payment_period`

        const body = JSON.stringify({
            service_id: currentId,
            payment_period: selectedPaymentPeriod?.value
        });

        fetch(url, { body, method: 'PATCH', headers })
            .then((res) => res.json())
            .then((json) => {
                console.log(`name changed`)
            })
            .catch((err) => console.error(err));
    };

    // Добавить тип оплаты
    const fetchSetPaymentType = () => {
        let url = ` https://portals.ecomru.ru/api/crm/services/payment_type`

        const body = JSON.stringify({
            service_id: currentId,
            payment_type: selectedPaymentType?.value
        });

        fetch(url, { body, method: 'PATCH', headers })
            .then((res) => res.json())
            .then((json) => {
                console.log(`name changed`)
            })
            .catch((err) => console.error(err));
    };

    // Добавить active
    const fetchSetActive = (active: boolean) => {
        let url = ` https://portals.ecomru.ru/api/crm/services/active`

        const body = JSON.stringify({
            service_id: currentId,
            active
        });

        fetch(url, { body, method: 'PATCH', headers })
            .then((res) => res.json())
            .then((json) => {
                console.log(`email changed`)
            })
            .catch((err) => console.error(err));
    };

    // Добавить телефон компании
    const fetchSetNeedReport = (need_report: boolean) => {
        let url = ` https://portals.ecomru.ru/api/crm/services/need_report`

        const body = JSON.stringify({
            service_id: currentId,
            need_report
        });

        fetch(url, { body, method: 'PATCH', headers })
            .then((res) => res.json())
            .then((json) => {
                console.log(`phone changed`)
            })
            .catch((err) => console.error(err));
    };

    // Добавить юридическое название
    const fetchSetLegalName = () => {
        let url = ` https://portals.ecomru.ru/api/crm/services/invoice_name`

        const body = JSON.stringify({
            service_id: currentId,
            invoice_name: legalName
        });

        fetch(url, { body, method: 'PATCH', headers })
            .then((res) => res.json())
            .then((json) => {
                console.log(`number changed`)
            })
            .catch((err) => console.error(err));
    };

    // Добавить комментарий
    const fetchSetComment = () => {
        let url = ` https://portals.ecomru.ru/api/crm/services/comment`

        const body = JSON.stringify({
            service_id: currentId,
            comment: comment
        });

        fetch(url, { body, method: 'PATCH', headers })
            .then((res) => res.json())
            .then((json) => {
                console.log(`number changed`)
            })
            .catch((err) => console.error(err));
    };

    // Получение контактов по компании
    const fetchGetContact = (id: number | string): void => {

        if (!id) return
        let url = ` https://portals.ecomru.ru/api/crm/companies/${id}/contacts?can_be_add=false`

        fetch(url, { method: 'GET', headers })
            .then((res) => {
                if (res.ok) {
                    return res.json();
                } else {
                    throw new Error(res.json() as any);
                }
            })
            .then((json) => {
                setContacts(json)
                const selected_contacts = json?.map(({ id, name, phone, email, address }) => ({
                    label: name,
                    value: id,
                    phone, email, address
                }))
                setSelectedContact(selected_contacts)
            })
            .catch((err) => {
                console.error(err);
            });
    };

    // Получение контактов к добавлению
    const fetchGetContactList = () => {
        let url = ` https://portals.ecomru.ru/api/crm/contacts/?page=${contactPage}&limit=50&search=${contactQuery}`

        fetch(url, { method: 'GET', headers })
            .then((res) => res.json())
            .then((json) => {
                const { data, total } = json
                if (contactPage > 1) {
                    setContactList((prev) => [...prev, ...data]);
                } else {
                    setContactList([...data]);
                }
            })
            .catch((err) => console.error(err));
    };

    useEffect(() => {
        fetchGetContactList();
    }, [contactPage, contactQuery]);

    // Получение доп полей компании
    const fetchGetFieldsList = (id: number | string): void => {
        let url = ` https://portals.ecomru.ru/api/crm/services/additional_fields/${id}`

        fetch(url, { method: 'GET', headers })
            .then((res) => res.json())
            .then((json) => {
                if (Array.isArray(json)) {
                    setFilds(json?.map(({ name, id, type, value, possible_values }) => ({ front_name: name, data_type: type, id: id, value: value ? JSON?.parse(value) : null, possible_values: possible_values })))
                }
            })
            .catch((err) => console.error(err));
    };

    // Запись полей
    const fetchSetValueField = (id: number | string, value: any): void => {
        let url = ` https://portals.ecomru.ru/api/crm/services/additional_fields/${currentId}`

        const body = JSON.stringify({
            field_id: id,
            value: (value !== null || value !== undefined) ? JSON?.stringify(value) : null
        })

        fetch(url, { method: 'POST', headers, body })
            .then((res) => res.json())
            .then((json) => {
                // if (Array.isArray(json)) {
                //     setFilds(json)
                // }
            })
            .catch((err) => console.error(err));
    };

    // Добавить компанию сделку в компанию
    const fetchBindDeal = () => {
        let url = ` https://portals.ecomru.ru/api/crm/deals/services`

        const body = JSON.stringify({
            deal_id: currentDeal,
            services_id: currentId
        });

        fetch(url, { body, method: 'PATCH', headers })
            .then((res) => res.json())
            .then((json) => {
                console.log('Компания добавлена в сделку')
            })
            .catch((err) => console.error(err));
    };

    useEffect(() => {
        if (currentServices) {
            fetchGetInfoServices()
        } else {
            fetchCreateNewServices()
        }
    }, [currentServices]);

    useEffect(() => {
        if (currentId && !isModalContactCRM) {
            fetchGetContact(currentId)
            fetchGetFieldsList(currentId)
        }
    }, [currentId, isModalContactCRM]);

    useEffect(() => {
        if (currentId) {
            fetchBindDeal()
        }
    }, [currentDeal, currentId]);

    const onClose = () => {
        if (!name) {
            fetchDeleteServices()
        }
        setCurrentServices(null)
        // setCurrentDeal(null)
        setIsModal(false)
    }



    return (
        <>
            {/* {isModalContactCRM && <ModalAddContactCRM
                currentServices={currentServices}
                isModal={false}
                setIsModal={setIsModalContactCRM}
            />} */}

            {isModalFields && <ModalAddFields
                setIsModal={setIsModalFields}
            />}

            <ModalComponent
                title={currentServices ? 'Редактирование услуги' : 'Добавление услуги'}
                onClose={onClose}
                right
                child={
                    <div className='modal-add-services-CRM'>
                        <div className='modal-add-services-CRM__main-content'>

                            <TitlePage
                                medium
                                title={'Основная информация'}
                            />

                            <div className='modal-add-services-CRM__content'>
                                <InputDinamycPlaceholder
                                    placeholder='Название услуги'
                                    onChange={setName}
                                    changeValue={name}
                                    onBlur={fetchSetName}
                                    size='s'
                                    required
                                />

                                <InputDinamycPlaceholder
                                    placeholder='Название для счета'
                                    onChange={setLegalName}
                                    changeValue={legalName}
                                    onBlur={fetchSetLegalName}
                                    size='s'
                                />

                                <InputDinamycPlaceholder
                                    placeholder='Единица измерения'
                                    onChange={setUnit}
                                    changeValue={unit}
                                    onBlur={fetchSetUnit}
                                    size='s'
                                />

                                <InputDinamycPlaceholder
                                    placeholder='Цена за единицу'
                                    onChange={setPrice}
                                    changeValue={price}
                                    onBlur={fetchSetPrice}
                                    size='s'
                                />

                                <InputDinamycPlaceholder
                                    placeholder='Всего единиц'
                                    onChange={setAmountUnit}
                                    changeValue={amountUnit}
                                    onBlur={fetchSetAmountUnit}
                                    size='s'
                                />

                                <InputDinamycPlaceholder
                                    placeholder='Общая сумма'
                                    onChange={setTotalSum}
                                    changeValue={totalSum}
                                    // onBlur={fetchSetTotalSum}
                                    size='s'
                                    disabled={true}
                                />

                                <DropDownSelector
                                    isClearable={false}
                                    state={selectedPaymentType}
                                    options_prop={option_payment_type}
                                    setState={setSelectedPaymentType}
                                    placeholder='Тип оплаты'
                                    maxWidth='100%'
                                    width='100%'
                                    onBlur={fetchSetPaymentType}
                                />

                                <DropDownSelector
                                    isClearable={false}
                                    state={selectedPaymentPart}
                                    options_prop={option_payment_part}
                                    setState={setSelectedPaymentPart}
                                    placeholder='Способ оплаты'
                                    maxWidth='100%'
                                    width='100%'
                                    onBlur={fetchSetPaymenPart}
                                />

                                <DropDownSelector
                                    isClearable={false}
                                    state={selectedPaymentPeriod}
                                    options_prop={option_payment_period}
                                    setState={setSelectedPaymentPeriod}
                                    placeholder='Период оплаты'
                                    maxWidth='100%'
                                    width='100%'
                                    onBlur={fetchSetPaymenPeriod}
                                />

                                {/* <TextareaDynamicPlaceholder
                                placeholder='Комментарии'
                                onChange={(e) => setComment(e)}
                                changeValue={comment}
                                onBlur={fetchSetComment}
                                size='s'
                                width='100%'
                            /> */}

                                <Checkbox
                                    value={active}
                                    onChange={(checked: boolean) => {
                                        setActive(checked)
                                        fetchSetActive(checked)
                                    }}
                                >Активно</Checkbox>

                                {/* <Checkbox
                                value={needReport}
                                onChange={(checked) => {
                                    setNeedReport(checked)
                                    fetchSetNeedReport(checked)
                                }}
                            >Требуется отчет</Checkbox> */}
                            </div>

                            {fields?.length ? <>
                                <TitlePage
                                    medium
                                    title={'Дополнительные поля'}
                                />

                                <div className='modal-add-services-CRM__content'>
                                    <DynamicFormComponent
                                        productTemporary={fields}
                                        fetchSetValue={fetchSetValueField as any}
                                    />
                                </div>
                            </> : null}
                        </div>
                    </div>
                }
            />
        </>
    )
}

export { ModalAddServicesCRM }